// import Icon from '@ant-design/icons';
//import { Button } from 'antd';
import { PlusOutlined, CloseCircleTwoTone } from '@ant-design/icons';
import React, { Fragment, useRef, useState } from 'react';
import Resizer from 'react-image-file-resizer';
import Compress from 'react-image-file-resizer';

// import { resolve } from 'url';
// @ts-ignore
import imageCompression from 'browser-image-compression';

interface UploadInputProps {
  children?: any;
  onClick?: any;
  isDisabled?: any;
  isPrimary?: any;
  isSubmit?: any;
  image: any;
  setImage: any;
}

function UploadInput({ setImage }: UploadInputProps) {
  //@ts-ignore
  // const [image, setImage] = useState<any>(null)
  const [imagePreviewUrl, setImagePreviewUrl] = useState<any>(null);
  const imgRef = useRef<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [imageName, setImageName] = useState<any>(null);

  // const [res, setRes] = useState<any>(false);

  //@ts-ignore
  const resizeFile = (file: any) => {
    new Promise(resolve => {
      Resizer.imageFileResizer(
        file,
        300,
        400,
        'JPEG',
        80,
        0,
        uri => {
          resolve(uri);
        },
        'base64',
      );
    });
  };

  //@ts-ignore to blob
  const dataURIToBlob = (dataURI: any) => {
    const splitDataURI = dataURI.split(',');
    const byteString =
      splitDataURI[0].indexOf('base64') >= 0
        ? atob(splitDataURI[1])
        : decodeURI(splitDataURI[1]);
    const mimeString = splitDataURI[0].split(':')[1].split(';')[0];
    const ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++)
      ia[i] = byteString.charCodeAt(i);
    return new Blob([ia], { type: mimeString });
  };

  // function blobToFile(theBlob:any, fileName:string) {
  //   //A Blob() is almost a File() - it's just missing the two properties below which we will add
  //   theBlob.lastModifiedDate = new Date();
  //   theBlob.name = fileName;
  //   return theBlob;
  // }

  // set imput img
  const handleImageChange = async (e: any) => {
    e.preventDefault();
    setIsLoading(true);

    let reader = new FileReader();
    const file = e.target.files[0];
    // file = await resizeFile(file);
    // fileComp = dataURIToBlob(fileComp)

    //TODO JIMP

    //TODO Browser img compression
    // const options = {
    //   maxSizeMB: 0.5,
    //   maxWidthOrHeight: 1920,
    //   useWebWorker: true
    // }
    let compFile_file: any;

    if (file !== null && file !== undefined) {
      console.log('File not null');
      try {
        // @ts-ignore
        // const compressedFile = await imageCompression(file, options);
        // file = compressedFile

        Compress.imageFileResizer(
          file,
          480,
          480,
          'JPEG',
          70,
          0,
          uri => {
            if (
              file.type == 'image/png' ||
              file.type == 'image/jpg' ||
              file.type == 'image/jpeg'
            ) {
              setImage(new File([dataURIToBlob(uri)], file.name));
            } else {
              setImage(null);
            }
          },
          'base64',
        );
        setImageName(file.name);
        compFile_file = new File([file], file.name && file.name);
        setIsLoading(false);
      } catch (error) {
        console.log(error);
      }
    }

    reader.onloadend = () => {
      if (
        file.type == 'image/png' ||
        file.type == 'image/jpg' ||
        file.type == 'image/jpeg'
      ) {
        setImage(compFile_file);
        setImagePreviewUrl(reader.result);
        console.log('match img type');
        console.log(compFile_file);
      } else {
        imgRef.current.value = '';
        setImage(null);
        setImagePreviewUrl(null);
      }
    };
    reader.readAsDataURL(file);
  };

  // ref button
  const uploadImg = () => {
    imgRef.current.click();
  };

  // reset image data
  const resetImg = () => {
    imgRef.current.value = '';
    setImage(null);
    setImagePreviewUrl(null);
  };

  return (
    <Fragment>
      <div className="upload-input-container">
        {isLoading}
        <input
          type="file"
          ref={imgRef}
          style={{ display: 'none' }}
          onChange={e => handleImageChange(e)}
          accept="image/png, image/jpeg, image/jpg"
        />
        {imagePreviewUrl ? (
          imagePreviewUrl && (
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                alignContent: 'center',
                height: '100%',
              }}
            >
              <div
                style={{
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <img
                  style={{
                    maxHeight: '150px',
                    borderRadius: '8px',
                  }}
                  src={imagePreviewUrl}
                />
                <CloseCircleTwoTone
                  style={{
                    position: 'absolute',
                    right: '0',
                    top: '0',
                  }}
                  onClick={() => resetImg()}
                  twoToneColor="#FF0000"
                />
                <div style={{}}>{imageName}</div>
              </div>
            </div>
          )
        ) : (
          <div onClick={() => uploadImg()} style={{ marginTop: 8 }}>
            {<PlusOutlined />}
            <div>Upload</div>
          </div>
        )}
      </div>
    </Fragment>
  );
}

export default UploadInput;
